import React from 'react'
import NavbarComp from './NavbarComp';




const About = () => {
    return ( 
<div>
<NavbarComp />
<h1>hdndjndjdjwj</h1>
</div>

     );
}
 
export default About;